import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { leadsApi, LeadContactSubmit, LeadNewsletterSubmit, LeadUpdate } from '../../services/api/leads';

// Public hooks (no auth needed)

export const useSubmitContact = () => {
  return useMutation({
    mutationFn: (data: LeadContactSubmit) => leadsApi.submitContact(data),
  });
};

export const useSubmitNewsletter = () => {
  return useMutation({
    mutationFn: (data: LeadNewsletterSubmit) => leadsApi.submitNewsletter(data),
  });
};

// Admin hooks

export const useLeads = (params?: {
  status?: string;
  form_type?: string;
  search?: string;
  skip?: number;
  limit?: number;
}) => {
  return useQuery({
    queryKey: ['leads', params],
    queryFn: () => leadsApi.getLeads(params),
  });
};

export const useLead = (id: string, enabled = true) => {
  return useQuery({
    queryKey: ['lead', id],
    queryFn: () => leadsApi.getLead(id),
    enabled: enabled && !!id,
  });
};

export const useUpdateLead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: LeadUpdate }) =>
      leadsApi.updateLead(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['lead'] });
    },
  });
};

export const useDeleteLead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => leadsApi.deleteLead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
    },
  });
};

export const useConvertLead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: { org_name: string; admin_email: string } }) =>
      leadsApi.convertLead(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['lead'] });
    },
  });
};
